export function companyInitials(company: string): string {
  const words = company.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso.slice(0, 10);
  }
}

// navigator.clipboard is unavailable in insecure contexts (plain HTTP on a
// non-localhost host, e.g. testing over a Tailscale IP) — silently no-ops
// there without this fallback. Shared by every copy-link button in the app.
export function copyToClipboard(text: string): Promise<boolean> {
  const fallback = () => {
    const el = document.createElement("textarea");
    el.value = text;
    el.style.position = "fixed";
    el.style.opacity = "0";
    document.body.appendChild(el);
    el.select();
    let ok = false;
    try {
      ok = document.execCommand("copy");
    } catch {
      ok = false;
    }
    document.body.removeChild(el);
    return ok;
  };
  if (navigator.clipboard) {
    return navigator.clipboard.writeText(text).then(() => true).catch(fallback);
  }
  return Promise.resolve(fallback());
}
